if (!customElements.get('omeny-bundle-selector')) {
  class OmenyBundleSelector extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-bundle-option]'));
      this.quantityInput = this.querySelector('[data-bundle-quantity]');
      this.summary = this.querySelector('[data-bundle-summary]');
      this.formId = this.dataset.formId;
      this.form = this.formId ? document.getElementById(this.formId) : null;
      this.submitLabel = this.form?.querySelector('[name="add"] span');
      this.originalSubmitLabel = this.submitLabel?.textContent?.trim() || '';

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.select(option));
        option.addEventListener('keydown', (event) => this.onKeydown(event, option));
      });

      const selected = this.querySelector('.is-selected') || this.options[0];
      if (selected) this.select(selected, false);
    }

    onKeydown(event, current) {
      if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
      event.preventDefault();
      const index = this.options.indexOf(current);
      const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
      const next = this.options[(index + direction + this.options.length) % this.options.length];
      next.focus();
      this.select(next);
    }

    select(option, announce = true) {
      const quantity = Math.max(1, Number.parseInt(option.dataset.quantity || '1', 10));

      this.options.forEach((item) => {
        const active = item === option;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });

      if (this.quantityInput) this.quantityInput.value = quantity;

      if (this.form) {
        this.form.querySelectorAll('input[name="quantity"]').forEach((input) => {
          input.value = quantity;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      if (this.summary && option.dataset.summary) {
        this.summary.textContent = option.dataset.summary;
      }

      if (this.submitLabel) {
        this.submitLabel.textContent = option.dataset.buttonLabel || this.originalSubmitLabel;
      }

      if (announce) {
        this.dispatchEvent(new CustomEvent('omeny:bundle-change', {
          bubbles: true,
          detail: { quantity, tier: option.dataset.tier }
        }));
      }
    }
  }

  customElements.define('omeny-bundle-selector', OmenyBundleSelector);
}
